var map = {
	"./brazil.jpg": 11163,
	"./catalonia.jpg": 91076,
	"./england.jpg": 50974,
	"./euskadi.jpg": 56695,
	"./french.jpg": 31129,
	"./galicia.jpg": 54371,
	"./germany.jpg": 96653,
	"./italy.jpg": 68468,
	"./russia.jpg": 30281,
	"./spain.jpg": 26346,
	"./us.jpg": 18683
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39415;